module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Add content":"Inhalt hinzufügen"}}')
  delete Component.options._Ctor
}
